// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nspan[data-v-4d141584]{\r\n    display: inline-block;\r\n    vertical-align: middle;\r\n    height: 14px;\r\n    width: 14px;\r\n    background: transparent center center 100%;\n}\r\n", ""]);
// Exports
module.exports = exports;
